import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const NavigationHistoryContext = createContext(undefined);

export const NavigationHistoryProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [history, setHistory] = useState(['/']);
  const lastPath = useRef('');

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    if (currentPath === lastPath.current) {
      return;
    }
    setHistory((prev) => {
      if (prev[prev.length - 1] !== currentPath) {
        return [...prev, currentPath];
      }
      return prev;
    });

    lastPath.current = currentPath;
  }, [location]);

  const goBack = () => {
    setHistory((prev) => {
      if (prev.length < 2) {
        return prev;
      }

      const newHistory = prev.slice(0, -1);
      const previous = newHistory[newHistory.length - 1];
      lastPath.current = previous;
      navigate(previous);
      return newHistory;
    });
  };

  return (
    <NavigationHistoryContext.Provider
      value={{
        history,
        canGoBack: history.length > 1,
        goBack,
      }}
    >
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export const useNavigationHistory = () => {
  const context = useContext(NavigationHistoryContext);
  return context;
};

NavigationHistoryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
